export function getCustomFontString(storiesUrl: string) {
  return `
  <style>
    @font-face {
      font-family: 'Benton';
      font-style: normal;
      font-weight: 400;
      src: url(${storiesUrl}/resources/fonts/Benton-Sans-Condensed-Regular.otf) format('OpenType'),
           url(${storiesUrl}/resources/fonts/Benton-Sans-Condensed-Regular.woff) format('woff');
    }

    @font-face {
      font-family: 'Benton';
      font-style: bold;
      font-weight: 700;
      src: url(${storiesUrl}/resources/fonts/Benton-Sans-Condensed-Bold.otf) format('OpenType'),
           url(${storiesUrl}/resources/fonts/Benton-Sans-Condensed-Bold.woff) format('woff');
    }

    @font-face {
      font-family: "ProximaNova";
      font-style: normal;
      font-weight: 400;
      src:  url('${storiesUrl}/resources/fonts/ProximaNova-Regular.woff2') format('woff2'),
            url('${storiesUrl}/resources/fonts/ProximaNova-Regular.woff') format('woff');
    }

    @font-face {
      font-family: "ProximaNova";
      font-style: bold;
      font-weight: 700;
      src:  url('${storiesUrl}/resources/fonts/ProximaNova-Bold.woff2') format('woff2'),
            url('${storiesUrl}/resources/fonts/ProximaNova-Bold.woff') format('woff');
    }
  </style>
`;
}
